import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled/macro'
import { pulse } from 'react-animations';
import { useInView } from 'react-intersection-observer'
import { animate, View } from "../AnimationsHelper";
import { useAwardsQuery } from '../../hooks/use-awards-query'
import { DiamondLine } from '../SVGs'
import { Device, Theme2, Container } from '../Layout'

const animation = keyframes`${pulse}`;

const AwardsSectionOuter = styled.div`
position: relative;
`
const AwardsSection = styled.div`

margin: 50px 0;
text-align: center;
a{
  text-decoration: none;
  background-color: ${Theme2.colors.tertiary};
  padding: 27px 25px;
  color: ${Theme2.colors.light};
  text-transform: uppercase;
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  transition: background-color 0.5s;
}
a:hover{
background-color: ${Theme2.colors.light2};
color: ${Theme2.colors.dark1};
}
@media ${Device.lg}{
  text-align: left;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 8%;
  margin: 7rem 4rem;
}
.awardsTitle{
  font-family: ${Theme2.fonts.headings};
font-size: 35px;
font-weight: 700;
line-height: 1.1;

.redText{
  color: ${Theme2.colors.tertiary};
}

@media ${Device.sm}{
  font-size: calc(35px + 45 * ((100vw - 576px) / 624));
}
@media ${Device.xl}{
  font-size: 80px;
}
&.animate {
					animation: 1s ${animation};
				}
}
`

const AwardsSubTitle = styled.p`
margin: 30px 0;
font-size: 20px;
line-height: 28px;
font-family: ${Theme2.fonts.alternateHeadings};
font-style: italic;
@media ${Device.sm}{
  font-size: calc(20px + 12 * ((100vw - 576px) / 624));
  line-height: calc(28px + 10 * ((100vw - 576px) / 624));
}
@media ${Device.xl}{
  font-size: 32px;
  line-height: 38px;
}
`
const DiamondLineContainer = styled.div`
display: none;
@media ${Device.lg}{
  display: inline;
  position: absolute;
  top:40px;
  left: -1650px;
  overflow-x: hidden;
  
  
}
`
const AwardsLogo = styled.div`
display: grid;
grid-template-columns: 1fr 1fr;
box-sizing: border-box;
grid-gap: 1px;

img{
 padding: 29px 24px;
  box-sizing: border-box;
  background-color: ${Theme2.colors.light};
}

@media ${Device.lg}{
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 0;
  .nationalTrialLawyers{
    grid-row: 2;
    grid-column: 2;
  }
  .leadCounsel{
    grid-row: 2;
    grid-column: 3;
  }
  .pacdl{
    grid-row: 3;
    grid-column: 3;
  }
  .gatsby-image-wrapper{
    border: 1px solid ${Theme2.colors.neutral};
  }
}
`
const AwardsLogoContainer = styled.div`
background-color: ${Theme2.colors.neutral};
border: 1px solid ${Theme2.colors.neutral};
box-sizing: border-box;
margin: 29px 0 42px 0;
@media ${Device.lg}{
  background-color: transparent;
  border: none;
}
`
const Awards = () =>{
  const { awardsTitleLineOne, awardsTitleRedText, awardsTitleLineThree, awardsSubtitle, awardsParagraph, awardsImages } = useAwardsQuery()
  const [ref, inView] = useInView(View)
    return(
      <Container >
      <AwardsSectionOuter>
<DiamondLineContainer>
        <DiamondLine />
        </DiamondLineContainer>
      
      <AwardsSection ref={ref}>
        
        
        <div>
        <div className={'awardsTitle '+animate(inView)}>{awardsTitleLineOne}<br />
        <span className="redText">{awardsTitleRedText}</span><br />
        {awardsTitleLineThree}</div>
        <AwardsSubTitle>{awardsSubtitle}</AwardsSubTitle>
        <div dangerouslySetInnerHTML={{__html: awardsParagraph}} />
        </div>
        
        <AwardsLogoContainer>
        
        <AwardsLogo>
        { awardsImages.map((awardsImage, i) => {
          
    const { awardsImagesImage, awardsImagesImageAltText, awardsImagesClass } = awardsImage;
    const awards = getImage(awardsImagesImage.localFile)
    return (
      
     <GatsbyImage key={i} objectFit="contain" className={awardsImagesClass} image={awards} alt={awardsImagesImageAltText} />
     
    )
  })}
</AwardsLogo>
</AwardsLogoContainer>

        </AwardsSection>
        
        </AwardsSectionOuter>
        </Container>
    )
}

export default Awards